import dayjs from 'dayjs'

/**
 * Map a calculRegistrationState() result to { color, label } for display.
 * `color` is a `--status-*` CSS variable name (consumed by StatusDot); `label`
 * is translated via the HOME_PAGE namespace, with MONTHS for the "OPEN AT" date.
 *
 * Moved here from Home/EventCard so the EventHub hero/sidebar reuse the exact
 * same status mapping instead of duplicating it.
 */
export const getRegistrationStatusDisplay = (status, t, tMonths, tz) => {
    const specialT = (value) => {
        if (value.includes('OPEN AT')) {
            const openDate = dayjs(value.split('OPEN AT ')[1]).tz(tz)
            return t('OPEN AT', {
                // The label around it is uppercase in all three languages ("OUVRE LE … À …"),
                // so the month has to be too or it reads as a typo on the badge.
                month: tMonths(openDate.format('MMMM')).toUpperCase(),
                day: openDate.format('DD'),
                time: openDate.format('HH:mm'),
            })
        }
        return t(value)
    }
    if (typeof status === 'string') {
        if (status.includes('OPEN AT')) return { color: '--status-openat', label: specialT(status) }
        if (status.includes('SOLD OUT')) return { color: '--status-soldout', label: t('Sold Out') }
        if (status.includes('REGISTER NOW')) return { color: '--status-open', label: t('Registration Open') }
    }
    return { color: '--status-closed', label: t('Registration Closed') }
}
